import { useEffect, useState } from "react";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";
import { Card, Col, Row } from "antd";
import { dispatch, useSelector } from "../../../redux/store";
import Loading from "../../../global/item/Loading/loading";
import { useTranslation } from "react-i18next";
import { getOtherType } from "../../../redux/action/otherType";
import { Home_Hotel } from "../../../utils/formatType";
import { Link } from "react-router-dom";
function OtherPage() {
  const { t } = useTranslation();
  const { otherTypeList } = useSelector((state) => state.otherType);
  console.log("otherTypeList", otherTypeList);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(getOtherType(Home_Hotel))
      .then(() => setLoading(false))
      .catch((error) => {
        setLoading(false);
      });
  }, []);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <TitleComponent
            title={"Dịch vụ khác"}
            type="primary"
            isExist={true}
          />
          {otherTypeList.map((item) => (
            <Link to={`/Home/Other/${item.id}`} key={item.id}>
              <Card className="layoutItem">
                <h3 style={{ color: `var(--primary-color)`, marginBottom: 8 }}>
                  {t("basicInformation")}
                </h3>
                <Row gutter={[20, 20]}>
  {/* Cột Text */}
  <Col xs={24} md={12}>
    <div>
      <p className="tilteForm">{t("title")}</p>
      <p className="descForm">{item.title}</p>
    </div>
    <div style={{ marginTop: 16 }}>
      <p className="tilteForm">{t("Mô tả")}</p>
      <p className="descForm">{item.description}</p>
    </div>
  </Col>

  {/* Cột Ảnh */}
  <Col xs={24} md={12}>
    {item.images?.[0] && (
      <div
        style={{
          width: "100%",        // chiếm hết chiều ngang cột
          aspectRatio: "3 / 2", // chiều ngang : chiều cao
          borderRadius: 10,
          overflow: "hidden",
          border: "1px solid #ddd",
        }}
      >
        <img
          src={item.images[0]}
          alt={item.title || "Uploaded image"}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
            backgroundColor: "#f0f0f0",
          }}
        />
      </div>
    )}
  </Col>
</Row>

              </Card>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}

export default OtherPage;
